import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown } from "react-icons/fa";
import Button from "../ui/Button";

function LayoutSelector({
  onChange,
  openPosition = "bottom",
  label = "Select Option", 
  disabled,
  selectedLayout = 'portrait',
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(selectedLayout);
  const dropdownRef = useRef(null);

  // Update selected when prop changes
  useEffect(() => {
    console.info('Updating selected layout:', selectedLayout);
    setSelected(selectedLayout);
  }, [selectedLayout]);

  // Toggle dropdown
  const toggleDropdown = () => {
    console.info('Toggling dropdown');
    setIsOpen((prev) => !prev);
  };

  // Handle selection
  const handleSelect = (value) => {
    console.info('Handling selection:', value);
    setIsOpen(false);
    onChange(value);
  };

  // Position dropdown menu
  const positionClasses = openPosition === "top" 
    ? "absolute left-0 bottom-full mb-2"
    : "absolute left-0 top-full mt-2";

  // Handle clicks outside dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        console.info('Closing dropdown on outside click');
        setIsOpen(false);
        setSelected(selectedLayout);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, selectedLayout]);

  return (
    <div className="relative inline-block w-fit" ref={dropdownRef}>
      <Button
        disabled={disabled}
        type="outline"
        onClick={toggleDropdown}
        className="w-full flex justify-between items-center"
      >
        {label}
        <FaChevronDown className="ml-2" />
      </Button>

      {isOpen && (
        <div
          className={`w-[400px] p-4 bg-white border border-gray-300 rounded-lg shadow-lg z-10 ${positionClasses}`}
        >
          <h3 className="text-lg font-medium mb-4">Change Layout</h3>
          <div className="flex gap-6 justify-center">
            <div
              onClick={() => {
                console.info('Selecting portrait layout');
                setSelected("portrait");
              }}
              className={`cursor-pointer w-[45%] ${
                selected === "portrait" ? "ring-2 ring-blue-500" : ""
              }`}
            >
              <img
                src="https://i.ibb.co/ynp5gVXZ/por-lay.jpg" 
                alt="Portrait layout"
                className="w-full h-auto object-cover border rounded"
              />
            </div>

            <div
              onClick={() => {
                console.info('Selecting landscape layout');
                setSelected("landscape");
              }}
              className={`cursor-pointer w-[45%] ${
                selected === "landscape" ? "ring-2 ring-blue-500" : ""
              }`}
            >
              <img 
                src="https://i.ibb.co/207jh9kR/lan-lay.png"
                alt="Landscape layout"
                className="w-full h-auto object-cover border rounded" 
              />
            </div>
          </div>

          <Button
            onClick={() => {
              handleSelect(selected);
              setIsOpen(false);
            }}
            className="w-full mt-6"
            disabled={selected === selectedLayout}
          >
            Apply
          </Button>
        </div>
      )}
    </div>
  );
}

export default LayoutSelector;